export class VideoSrc {
  public src: string;
  public type: string;
}
